/**
 * About modal component displaying application version and information.
 */

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button } from 'react-bootstrap';
import { getVersion } from '@/utils/version';

interface AboutModalProps {
  show: boolean;
  onHide: () => void;
}

export default function AboutModal({ show, onHide }: AboutModalProps) {
  const { t } = useTranslation();
  const [version, setVersion] = useState<string>('');

  useEffect(() => {
    if (show) {
      getVersion().then(setVersion).catch(() => setVersion('1.0.0'));
    }
  }, [show]);

  return (
    <Modal show={show} onHide={onHide} centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>About</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ textAlign: 'center', padding: '1rem 0' }}>
          <div style={{ marginBottom: '1.5rem' }}>
            <img
              src="/myant-logo.png"
              alt="Myant Logo"
              style={{
                height: '48px',
                width: 'auto',
                marginBottom: '1rem',
              }}
              onError={(e) => {
                e.currentTarget.style.display = 'none';
              }}
            />
            <h4 style={{ marginBottom: '0.5rem', color: 'var(--myant-text-primary)' }}>
              {t('navbar.dataShop')}
            </h4>
            <p style={{ color: 'var(--myant-text-secondary)', fontSize: '0.9rem', marginBottom: '0' }}>
              Data Shop Platform
            </p>
          </div>
          <div style={{ borderTop: '1px solid var(--myant-border-color)', paddingTop: '1.5rem', marginTop: '1.5rem' }}>
            <div style={{ marginBottom: '1rem' }}>
              <strong style={{ color: 'var(--myant-text-primary)', display: 'block', marginBottom: '0.25rem' }}>
                Version
              </strong>
              <span style={{ color: 'var(--myant-text-secondary)', fontSize: '0.95rem' }}>
                {version || 'Loading...'}
              </span>
            </div>
            <div style={{ marginBottom: '1rem' }}>
              <strong style={{ color: 'var(--myant-text-primary)', display: 'block', marginBottom: '0.25rem' }}>
                Copyright
              </strong>
              <span style={{ color: 'var(--myant-text-secondary)', fontSize: '0.95rem' }}>
                © {new Date().getFullYear()} Myant Inc. All rights reserved.
              </span>
            </div>
            <div>
              <p style={{ color: 'var(--myant-text-secondary)', fontSize: '0.85rem', marginTop: '1rem', marginBottom: '0' }}>
                Data Shop is a platform for browsing, ordering, and downloading datasets.
              </p>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
